import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators';
import store from '@/store';
import * as Api from '@xlearn/common';
import { TocItem, CourseAspect, AspectSelectInfo } from '@/app/shared/models';

@Module({
  namespaced: true,
  name: 'aspect',
  store,
  dynamic: true
})
class AspectStoreModule extends VuexModule {
  public course: Api.SerializedCourse|null = null;
  public selectedCourseAspectInstance: CourseAspect|null = null;
  public selectedChapter: TocItem|null = null;
  public flatPages: string[] = [];
  public sectionsById: { [sectionId: string]: TocItem } = {};
  public aspects: AspectSelectInfo[]|null = null;
  public selectedAspectInstanceId: string|null = null;
  public shouldUserSelectAspect: boolean = true

  public get courseId(): string|null {
    if (!this.selectedCourseAspectInstance) {
      return null;
    }

    return this.selectedCourseAspectInstance.courseId;
  }

  // public get quizzes(): Quiz[] {
  //   if (this.selectedCourseAspectInstance === null) {
  //     return [];
  //   }

  //   return this.selectedCourseAspectInstance.quizzes;
  // }

  // // OBSOLETE
  // public get finalQuizId(): string|null {
  //   if (this.selectedCourseAspectInstance === null
  //     || this.selectedCourseAspectInstance.finalQuizId === null
  //     || this.selectedCourseAspectInstance.finalQuizId === '') {
  //     return null;
  //   }

  //   return this.selectedCourseAspectInstance.finalQuizId;
  // }

  @Mutation
  public setCourse(value: Api.SerializedCourse): void {
    this.course = value;
  }

  @Mutation
  public setSelectedCourseAspect(value: CourseAspect|null): void {
    this.selectedCourseAspectInstance = value;
  }

  @Mutation
  public setSelectedChapter(value: TocItem|null): void {
    this.selectedChapter = value;
  }

  @Mutation
  public setFlatPages(value: string[]): void {
    this.flatPages = value;
  }

  @Mutation
  public setSectionsById(value: { [sectionId: string]: TocItem }): void {
    this.sectionsById = value;
  }

  @Mutation
  public setAspects(value: AspectSelectInfo[]): void {
    this.aspects = value;
  }

  @Mutation
  public setSelectedAspectInstanceId(value: string|null): void {
    this.selectedAspectInstanceId = value;
  }

  @Mutation
  public disableStartupAspectSelection() {
    this.shouldUserSelectAspect = false
  }

  @Mutation
  public enableStartupAspectSelection() {
    this.shouldUserSelectAspect = true
  }
}

export default getModule(AspectStoreModule);
